import { css } from 'styled-system/css'

// Matches the Editorial-Minimal prototype's .seg / .seg button / .seg
// button.on exactly: a muted track (--btn2-bg) holding a card-colored
// selected pill (--card) with a subtle shadow — not a solid ink fill, which
// inverts to a jarring near-white pill in dark mode.
export const segTrack = css({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '0.5',
  bg: 'var(--colors-editorial-btn2-bg)',
  borderRadius: '10px',
  p: '3px',
})

// Single css() call per state so the background/color rules never have to
// fight another atomic class at equal specificity.
export const segButton = (active: boolean) => css({
  border: 'none',
  fontWeight: '600',
  fontSize: '12.5px',
  px: '11px',
  py: '6px',
  borderRadius: '7px',
  cursor: 'pointer',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  transition: 'background 0.15s, color 0.15s',
  bg: active ? 'var(--colors-editorial-panel)' : 'transparent',
  color: active ? 'var(--colors-editorial-ink)' : 'var(--colors-editorial-btn2-fg)',
  boxShadow: active ? '0 1px 2px rgba(0, 0, 0, .12)' : 'none',
})
